import { format, parse } from "date-fns"
import { calcularDiferencaEmDias, converteDataProtheus, convertSpecialCharsToHtml, formatarComoDecimal, formatarComoMoeda, formatarData, optionsPrioridade, parseLocaleNumber } from "../../contents/VariaveisGlobais"
import UploadFiles from "../UploadFiles"
import { BlackFontTrello, CelBreak, CelBreak25, NormalFont } from "./styles"
import { handleFilaAprovadores } from "./Pedido"
import FichaPedidosCompra from "../../pages/Compras/FichaPedidosCompra"
import { handleHistoricoProduto } from "./Aprovacao"

function handlePrioridadeSCColumn(item){
    const options = optionsPrioridade
    const prioridade = item.value.trim() || "1"
    const prioridadeOption = options.filter( (option) => option.value === prioridade)

    return prioridadeOption.length > 0 ? prioridadeOption[0].text : ""
}

function handleNumeroItemSCColumn(item, DisparaBootBox, FechaBootBox, navigate){
    const { C1_NUM, EMPRESA, C1_FILIAL, C1_ITEM, C1_PEDIDO, C1_COTACAO } = item.row.original;

    return ( <>
                {<NormalFont tooltipText={"Fila de Aprovadores"} onClick={(e)=> handleFilaAprovadores("SC", C1_NUM, EMPRESA, C1_FILIAL, DisparaBootBox, FechaBootBox)}><strong>Fil.: </strong>{C1_FILIAL}</NormalFont>}
                <br/><NormalFont><strong>SC: {item.value} </strong></NormalFont>
                <br/><NormalFont><strong>Item: </strong> {C1_ITEM}</NormalFont>
                { C1_COTACAO && C1_COTACAO.trim() && <><br/><NormalFont><strong>Cot: </strong>{C1_COTACAO}</NormalFont></> }
                { C1_PEDIDO && C1_PEDIDO.trim() && <><br/><NormalFont tooltipText={"Abrir Pedido de Compra"} onClick={()=> handleAbrirPC(EMPRESA, C1_FILIAL, C1_PEDIDO, DisparaBootBox, FechaBootBox)}><strong>PC: </strong>{C1_PEDIDO}</NormalFont></> }
            </> )
}

function handleCheckSC(e, item){
    item.data[item.row.index].Check = true;
    item.row.original.Check = true;
}

function handleCheckColumnSC(item) {
    return (
        <input
            type="checkbox"
            checked={item.Check}
            onChange={(e) => handleCheckSC(e, item)}
        />
    );
}

function handleProdutoSCColumn(item){
    const {DESCRI, C1_SOLICIT, C1_CODCOMP, Y1_NOME, C1_CC, CTT_DESC01, C1_XFLUXSC, C1_TIPCOM, DHK_DESCR} = item.row.original

    const options = optionsPrioridade
    const prioridade = C1_XFLUXSC.trim() || "1"
    const prioridadeOption = options.filter( (option) => option.value === prioridade)
    const prioridadeText = prioridadeOption.length > 0 ? prioridadeOption[0].text : ""

    return ( <CelBreak>
                <strong>{item.value.trim()}</strong> - {DESCRI.trim()}
                <p>
                    <strong>Finalidade: </strong> {C1_TIPCOM.trim() + ' - ' + DHK_DESCR.trim()}
                    <br/><strong>Prioridade: </strong> {prioridadeText.trim()}
                    <br/><strong>Solic.: </strong> {C1_SOLICIT.trim()}
                    <br/><strong>Comp.: </strong> {C1_CODCOMP.trim()} - {Y1_NOME.trim()}
                    <br/><strong>CC: </strong>{C1_CC.trim()} - {CTT_DESC01.trim()}
                </p>
                
            </CelBreak> )
}

function handleProdutoSCCard(item, acessor, header, data, setData, disabledForm, AbreBox, FechaBox){
    const { EMPRESA, C1_FILIAL, DESCRI, C1_UM, C1_PRODUTO} = item.row.original
    const empresaFilial = EMPRESA + '-' + item.C1_FILIAL
    
    return <>
        <BlackFontTrello 
            tooltipText={`Ultimas Compras Produto: ${item.value.trim()}`} 
            onClick={(e) => handleHistoricoProduto(C1_PRODUTO, empresaFilial, AbreBox, FechaBox)} 
        >
            ({C1_PRODUTO})
        </BlackFontTrello> 
        { " - " + DESCRI + ' (' + C1_UM + ')'}
    </>
}

function handleCompradorSCColumn(item){
    return ( <>
                <p><strong>Solic.: </strong> {item.row.original.C1_SOLICIT}</p>
                <p><strong>Comp.: </strong> {item.row.original.C1_CODCOMP} - {item.row.original.Y1_NOME}</p>
            </> )
}

function handleQtdValorSCCard(item){
    const options = optionsPrioridade    
    const prioridade = item.row.original.C1_XFLUXSC.trim() || "N"

    const prioridadeOption = options.filter( (option) => option.value === prioridade)
    const unitario = formatarComoMoeda(item.row.original.C1_PRECO, 4)
    const total = formatarComoMoeda(item.row.original.C1_TOTAL)
    const qtde = formatarComoDecimal(item.value, 4)

    const periodo = item.row.original.C1_XPERIO === 'D' ? 'Dias ' : item.row.original.C1_XPERIO === 'M' ? 'Meses ' : item.row.original.C1_XPERIO === 'A' ? 'Anos ' : ''
    const locado = item.row.original.C1_XLOC
    
    return ( 
    <>
        <p className="d-flex justify-content-between">
            <div><strong>Qtde.: </strong> {qtde}</div>
            <div><strong>Unitário: </strong> {unitario}</div>
        </p>    
        <p className="d-flex justify-content-between">
            { prioridadeOption && prioridadeOption.length > 0 && ( 
                <div><strong>Prioridade: </strong> {prioridadeOption[0].text}</div> 
            ) }
            <div><strong>Total: {total} </strong></div>
        </p>
        { periodo && (
            <div><strong>{periodo}: {locado} </strong></div> 
        )}
    </> )
}

function handleQtdValorSCColumn(item){
    const unitario = formatarComoMoeda(item.row.original.C1_PRECO, 4)
    const total = formatarComoMoeda(item.row.original.C1_TOTAL)
    const quantidade = formatarComoDecimal(item.value)
    const periodo = item.row.original.C1_XPERIO === 'D' ? 'Dias ' : item.row.original.C1_XPERIO === 'M' ? 'Meses ' : item.row.original.C1_XPERIO === 'A' ? 'Anos ' : ''
    const locado = item.row.original.C1_XLOC

    return ( <>
        <strong>Qtd.: </strong>{quantidade}
        <br/><strong>Unitário: </strong>{unitario}
        <br/><strong>Total: {total} </strong>
        { periodo && (<><br/><strong>{periodo}: {locado} </strong></>) }
    </> )
}

function handleSCDataPrevisaoCard(item, returnText = false){
    let dataNecessidade = converteDataProtheus(item.row.original.C1_DATPRF);
    let dataEmissao = converteDataProtheus(item.row.original.C1_EMISSAO);
    let dataAprovacao = item.row.original.C1_XDTAPRV.trim() ? converteDataProtheus(item.row.original.C1_XDTAPRV) : dataNecessidade;
    let diasDif = item.row.original.C1_XDTAPRV.trim() ? calcularDiferencaEmDias(dataEmissao, dataNecessidade) : 0;

    if (diasDif > 0){
        dataAprovacao = parse(dataAprovacao, 'yyyy-MM-dd', new Date())
        dataAprovacao.setDate(dataAprovacao.getDate() + diasDif);
        dataAprovacao = format(dataAprovacao, 'yyyy-MM-dd');
    }

    return ( <p>
        <strong>Previsão: </strong> {formatarData(dataAprovacao)} 
    </p>)
}

function handleQtdUnitarioCard(item){
    return ( <div className="d-flex justify-content-between">
                <div><strong>Qtde.: </strong> {item.quantidade}</div>
                <div><strong>Valor Unitário: </strong> {formatarComoMoeda(parseLocaleNumber(item.valorUnitario),4)}</div>
            </div> )
}

function handleQtdUnitario(item){
    return ( <div className="d-flex justify-content-between">
                <div><strong>Qtde.: </strong> {item.quantidade}</div>
                <div><strong>Valor Unitário: </strong> {formatarComoMoeda(item.valorUnitario,4)}</div>
            </div> )
}

function handleValorTotalCard(item){
    return ( <div>
                <strong>Valor Total: </strong> {formatarComoMoeda(parseLocaleNumber(item.valorTotal),2)}
            </div> )
}

function handleValorTotal(item){
    return ( <div>
                <strong>Valor Total: </strong> {formatarComoMoeda(item.valorTotal,2)}
            </div> )
}

function handleObservacaoInternaCard(item){
    return ( <p>
                <span><strong>Observacao Interna: </strong></span>
                <span dangerouslySetInnerHTML={{ __html: convertSpecialCharsToHtml(item.value || "") }} />
            </p> )
}

function handleObservacaoInterna(item){
    return ( <div>
                <div><strong>Observacao Interna: </strong></div>
                <div dangerouslySetInnerHTML={{ __html: convertSpecialCharsToHtml(item.value || "") }} />
            </div> )
}

function handleSCDataEmissaoCard(item){
    const dtEmissao = formatarData(item.value)
    let dataNecessidade = converteDataProtheus(item.row.original.C1_DATPRF);
    let dataEmissao = converteDataProtheus(item.row.original.C1_EMISSAO);
    let dataAprovacao = item.row.original.C1_XDTAPRV.trim() ? converteDataProtheus(item.row.original.C1_XDTAPRV) : dataNecessidade;
    let diasDif = item.row.original.C1_XDTAPRV.trim() ? calcularDiferencaEmDias(dataEmissao, dataNecessidade) : 0;

    if (diasDif > 0){
        dataAprovacao = parse(dataAprovacao, 'yyyy-MM-dd', new Date())
        dataAprovacao.setDate(dataAprovacao.getDate() + diasDif);
        dataAprovacao = format(dataAprovacao, 'yyyy-MM-dd');
    }

    return ( <p className="d-flex justify-content-between">
        <div><strong>Emissão: </strong> {dtEmissao}</div>
        <div><strong>Previsão: </strong> {formatarData(dataAprovacao)} </div>
    </p> )
}

function handleSCPrioridadeCard(item){
    const options = optionsPrioridade    
    const prioridade = item.value.trim() || "N"

    const prioridadeOption = options.filter( (option) => option.value === prioridade)

    return (
        <>
            { prioridadeOption && prioridadeOption.length > 0 && ( 
                <p>
                    <strong>Prioridade: </strong> {prioridadeOption[0].text}
                </p> 
            ) }
        </>
    )
}

function handleSCCentroCustoCard(item){

    return ( 
        <>
            <p>
                <strong>CC: </strong> {item.value} - {item.CTT_DESC01}
            </p> 
            { item.C1_XCA && item.C1_XCA.trim() && (
                <p>
                    <strong>C. A.: </strong> {item.C1_XCA}
                </p> 
            )}
        </> 
    )
}

function handleSCAnexosDecode(item){
    try{
        const anexosJson = JSON.parse(item.value)

        return ( <div style={{ marginBottom: '8px' }}>
            <span><strong>{item.Header}: </strong></span>
                <UploadFiles
                    value={anexosJson}
                    disabled={true}
                />
        </div> )
    }catch(e){
        return ''
    }
}

function handleAnexos(item, acessor, header){
    let objAnexoRender
    try {
        objAnexoRender = JSON.parse((item.value.trim() || '[]').replaceAll('ORIGINALNAME', 'originalname').replaceAll('FILENAME', 'filename'))        
    } catch (error) {
        objAnexoRender = JSON.parse('[]')
    }
    
    return ( <div>
                <div><strong>{header}: </strong></div>
                    <UploadFiles
                        value={objAnexoRender}
                        disabled={true}
                    />
            </div> )
}

const handleAbrirPC = (Empresa, Filial, Numero, DisparaBootBox, FechaBootBox) => {
    // Renderiza o componente diretamente no BootBox
    DisparaBootBox(
        `Pedido de Compras - Nº ${Numero}`,
        () => <FichaPedidosCompra 
            idPedidoCompra={Numero}
            empresaFilialCompras={Empresa+''+Filial}/>,
        [{ variant: 'light', action: FechaBootBox, label: '↩ Fechar' }],
        null,
        false,
        'xl',
        true,
        true // withComponent = true
    );
    
    // navigate(`../compras/Solicitacoes/Visualizar/${Numero}/0000/$`)
}


function handleStatusSC(item, DisparaBootBox, FechaBootBox, navigate) {
    const {
        C1_QUJE = "0",
        C1_COTACAO = '',
        C1_PEDIDO = '',
        C1_APROV = '',
        C1_QUANT = "0",
        C1_RESIDUO = '',
        C1_FLAGGCT = "0",
        C1_XMOTIV
    } = item.row.original;

    // Aplica trim nos campos e converte para número onde necessário
    const quje = Number(C1_QUJE.trim());
    const quant = Number(C1_QUANT.trim());
    const flagGCT = Number(C1_FLAGGCT.trim());
    const cotacao = C1_COTACAO.trim();
    const aprov = C1_APROV.trim();
    const pedido = C1_PEDIDO.trim();
    const residuo = C1_RESIDUO.trim();
    let cStatus = 'Indeterminado';

    if (residuo === 'S' && cStatus === 'Indeterminado') {
        cStatus = 'Eliminado Residuo';
    }
    if ('D|0'.includes(aprov)  && cStatus === 'Indeterminado') {
        cStatus = <NormalFont tooltipText={C1_XMOTIV} style={{ padding: '1vh 0' }}>Devolvida</NormalFont>
    }
    if (aprov === 'C' && cStatus === 'Indeterminado') {
        cStatus = 'Cancelada'
    }
    if (flagGCT === 1 && quje < quant && cStatus === 'Indeterminado') {
        cStatus = 'Contrato GCT';
    }
    if (quje === 0 && cotacao === '' && aprov === 'L' && cStatus === 'Indeterminado') {
        cStatus = 'Pendente';
    }
    if (quje === 0 && (cotacao === '' || cotacao === 'IMPORT') && aprov === 'B' && cStatus === 'Indeterminado') {
        cStatus = 'Em Aprovação';
    }
    if (quje === 0 && (cotacao === '' || cotacao === 'IMPORT') && aprov === 'R' && cStatus === 'Indeterminado') {
        cStatus = 'Rejeitada';
    }
    if (quje > 0 && quje < quant && cotacao !== '' && cStatus === 'Indeterminado') {
        cStatus = 'Parcialmente em Cotação';
    }    
    if (quje > 0 && quje < quant && cotacao === '' && cStatus === 'Indeterminado') {
        cStatus = 'Parcialmente Utilizada';
    }
    if (quant !== quje && cotacao !== '' && cStatus === 'Indeterminado') {
        cStatus = 'Em Cotação';
    }
    if (quant === quje && cotacao !== '' && cStatus === 'Indeterminado') {
        cStatus = (pedido ? 'Pedido de Compra Gerado' : 'Finalizada em Cotação');
    }
    if (quant === quje && cStatus === 'Indeterminado') {
        cStatus = (pedido ? 'Pedido de Compra Gerado' : 'Finalizado');
    }

    return cStatus
}

export { handleSCAnexosDecode, handleSCCentroCustoCard, handleSCDataEmissaoCard, handleSCDataPrevisaoCard, handleSCPrioridadeCard, handleCheckColumnSC, handleStatusSC, handlePrioridadeSCColumn, handleNumeroItemSCColumn, handleProdutoSCColumn, handleProdutoSCCard, handleCompradorSCColumn, handleQtdValorSCColumn, handleQtdValorSCCard, handleQtdUnitario, handleQtdUnitarioCard, handleValorTotal, handleValorTotalCard, handleObservacaoInterna, handleObservacaoInternaCard, handleAnexos, handleAbrirPC }